export default "/images/44de997aeb1371e2e3f7eb9fd11386bc.avif";